import { FC } from 'react';
import { Grid } from '@mui/material';

import { useHatDashboardPageContext } from '../../../hooks/Pages/HatDashboardPage';
import HatUtils from '../../../utils/HatUtils';
import MetricCard from '../../../components/Metrics/MetricCard';

const HatMetrics: FC = (): React.JSX.Element => {
    const { hasHatCriteriaPreviousDateRange, metrics } = useHatDashboardPageContext();

    return (
        <Grid container spacing={2}>
            <Grid item xs={3}>
                <MetricCard
                    loading={metrics?.TOTAL_UNIQUE_TRAFFIC?.isLoading ?? false}
                    metric={
                        metrics?.TOTAL_UNIQUE_TRAFFIC
                            ? {
                                  ...metrics?.TOTAL_UNIQUE_TRAFFIC,
                                  changeLabel: HatUtils.formatPercent(metrics.TOTAL_UNIQUE_TRAFFIC.change),
                              }
                            : undefined
                    }
                    label="Total Visits"
                    tooltip=""
                    hideSublabel={!hasHatCriteriaPreviousDateRange}
                    hideChangePeriodLabel={true}
                />
            </Grid>

            <Grid item xs={3}>
                <MetricCard
                    loading={metrics?.TOTAL_AD_INFLUENCED_TRAFFIC?.isLoading ?? false}
                    metric={
                        metrics?.TOTAL_AD_INFLUENCED_TRAFFIC
                            ? {
                                  ...metrics?.TOTAL_AD_INFLUENCED_TRAFFIC,
                                  changeLabel: HatUtils.formatPercent(metrics.TOTAL_AD_INFLUENCED_TRAFFIC.change),
                              }
                            : undefined
                    }
                    label="Attributed Visits"
                    tooltip="Visits that can be directly attributed to our campaigns, and are reclassified from other channels."
                    hideSublabel={!hasHatCriteriaPreviousDateRange}
                    hideChangePeriodLabel={true}
                />
            </Grid>

            <Grid item xs={3}>
                <MetricCard
                    loading={metrics?.TOTAL_CONVERSIONS?.isLoading ?? false}
                    metric={
                        metrics?.TOTAL_CONVERSIONS
                            ? {
                                  ...metrics?.TOTAL_CONVERSIONS,
                                  changeLabel: HatUtils.formatPercent(metrics.TOTAL_CONVERSIONS.change),
                              }
                            : undefined
                    }
                    label="Total Actions"
                    tooltip=""
                    hideSublabel={!hasHatCriteriaPreviousDateRange}
                    hideChangePeriodLabel={true}
                />
            </Grid>

            <Grid item xs={3}>
                <MetricCard
                    loading={metrics?.TOTAL_AD_INFLUENCED_CONVERSIONS?.isLoading ?? false}
                    metric={
                        metrics?.TOTAL_AD_INFLUENCED_CONVERSIONS
                            ? {
                                  ...metrics?.TOTAL_AD_INFLUENCED_CONVERSIONS,
                                  changeLabel: HatUtils.formatPercent(metrics.TOTAL_AD_INFLUENCED_CONVERSIONS.change),
                              }
                            : undefined
                    }
                    label="Attributed Actions"
                    tooltip="Actions that can be directly attributed to our campaigns, and are reclassified from other channels."
                    hideSublabel={!hasHatCriteriaPreviousDateRange}
                    hideChangePeriodLabel={true}
                />
            </Grid>
        </Grid>
    );
};

export default HatMetrics;
